var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayairSmallLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4801 3.14591C17.8589 3.14591 18.9791 4.25876 18.9791 5.62841V16.3716C18.9791 17.7412 17.8589 18.8541 16.4801 18.8541H5.66572C4.28699 18.8541 3.16677 17.7412 3.16677 16.3716V5.62841C3.16677 4.25876 4.28699 3.14591 5.66572 3.14591H16.4801ZM5.66572 0C2.54203 0 0 2.52529 0 5.62841V16.3716C0 19.4747 2.54203 22 5.66572 22H16.4801C19.6038 22 22.1459 19.4747 22.1459 16.3716V5.62841C22.1459 2.52529 19.6038 0 16.4801 0H5.66572Z",
    fill: "#17264D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50059 6.29185H6.33382V9.43776H9.50059V6.29185Z",
    fill: "#17264D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8124 6.29185H12.6456V9.43776H15.8124V6.29185Z",
    fill: "#17264D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50059 12.5623H6.33382V15.7082H9.50059V12.5623Z",
    fill: "#17264D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayairSmallLogo);
export default __webpack_public_path__ + "static/media/payairSmallLogo.257ed2c232d75baf02101f726065ea7f.svg";
export { ForwardRef as ReactComponent };